// @generated by protoc-gen-es v2.9.0 with parameter "import_extension=js"
// @generated from file services/webscrape/resources/webscrape.proto (package gx.webscrape.resources, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_struct } from "@bufbuild/protobuf/wkt";

/**
 * Describes the file services/webscrape/resources/webscrape.proto.
 */
export const file_services_webscrape_resources_webscrape = /*@__PURE__*/
  fileDesc("CixzZXJ2aWNlcy93ZWJzY3JhcGUvcmVzb3VyY2VzL3dlYnNjcmFwZS5wcm90bxIWZ3gud2Vic2NyYXBlLnJlc291cmNlcyIsCg5EaXNjb3ZlcmVkTGluaxILCgN1cmwYASABKAkSDQoFdGl0bGUYAiABKAkirwEKC1NjcmFwZWRQYWdlEgsKA3VybBgBIAEoCRIQCghtYXJrZG93bhgCIAEoCRI5CgluZXdfbGlua3MYAyADKAsyJi5neC53ZWJzY3JhcGUucmVzb3VyY2VzLkRpc2NvdmVyZWRMaW5rEhsKE3NjcmVlbnNob3RfaGlnaF9yZXMYBCABKAwSGgoSc2NyZWVuc2hvdF9sb3dfcmVzGAUgASgMEg0KBWVycm9yGAYgASgJIlwKDlByb3ZpZGVyQ29uZmlnEkAKC2Jyb3dzZXJiYXNlGAEgASgLMikuZ3gud2Vic2NyYXBlLnJlc291cmNlcy5Ccm93c2VyYmFzZUNvbmZpZ0gAQggKBmNvbmZpZyI4ChFCcm93c2VyYmFzZUNvbmZpZxIPCgdhcGlfa2V5GAEgASgJEhIKCnByb2plY3RfaWQYAiABKAkiXgoOU2Vzc2lvbkRldGFpbHMSQQoLYnJvd3NlcmJhc2UYASABKAsyKi5neC53ZWJzY3JhcGUucmVzb3VyY2VzLkJyb3dzZXJiYXNlU2Vzc2lvbkgAQgkKB2RldGFpbHMiZQoSQnJvd3NlcmJhc2VTZXNzaW9uEhIKCnNlc3Npb25faWQYASABKAkSDwoHY2RwX3VybBgCIAEoCRISCgpyZXBsYXlfdXJsGAMgASgJEhYKDmxpdmVfdmlld19saW5rGAQgASgJKkwKDFByb3ZpZGVyVHlwZRIdChlQUk9WSURFUl9UWVBFX1VOU1BFQ0lGSUVEEAASHQoZUFJPVklERVJfVFlQRV9CUk9XU0VSQkFTRRABQvABChpjb20uZ3gud2Vic2NyYXBlLnJlc291cmNlc0IOV2Vic2NyYXBlUHJvdG9QAVpIZ2l0aHViLmNvbS9nYWxheHktaW8vZ3gvc2hhcmVkL2dvL2NvbnRyYWN0cy9zZXJ2aWNlcy93ZWJzY3JhcGUvcmVzb3VyY2VzogIDR1dSqgIWR3guV2Vic2NyYXBlLlJlc291cmNlc8oCFkd4XFdlYnNjcmFwZVxSZXNvdXJjZXPiAiJHeFxXZWJzY3JhcGVcUmVzb3VyY2VzXEdQQk1ldGFkYXRh6gIYR3g6OldlYnNjcmFwZTo6UmVzb3VyY2VzYgZwcm90bzM", [file_google_protobuf_struct]);

/**
 * Describes the message gx.webscrape.resources.DiscoveredLink.
 * Use `create(DiscoveredLinkSchema)` to create a new message.
 */
export const DiscoveredLinkSchema = /*@__PURE__*/
  messageDesc(file_services_webscrape_resources_webscrape, 0);

/**
 * Describes the message gx.webscrape.resources.ScrapedPage.
 * Use `create(ScrapedPageSchema)` to create a new message.
 */
export const ScrapedPageSchema = /*@__PURE__*/
  messageDesc(file_services_webscrape_resources_webscrape, 1);

/**
 * Describes the message gx.webscrape.resources.ProviderConfig.
 * Use `create(ProviderConfigSchema)` to create a new message.
 */
export const ProviderConfigSchema = /*@__PURE__*/
  messageDesc(file_services_webscrape_resources_webscrape, 2);

/**
 * Describes the message gx.webscrape.resources.BrowserbaseConfig.
 * Use `create(BrowserbaseConfigSchema)` to create a new message.
 */
export const BrowserbaseConfigSchema = /*@__PURE__*/
  messageDesc(file_services_webscrape_resources_webscrape, 3);

/**
 * Describes the message gx.webscrape.resources.SessionDetails.
 * Use `create(SessionDetailsSchema)` to create a new message.
 */
export const SessionDetailsSchema = /*@__PURE__*/
  messageDesc(file_services_webscrape_resources_webscrape, 4);

/**
 * Describes the message gx.webscrape.resources.BrowserbaseSession.
 * Use `create(BrowserbaseSessionSchema)` to create a new message.
 */
export const BrowserbaseSessionSchema = /*@__PURE__*/
  messageDesc(file_services_webscrape_resources_webscrape, 5);

/**
 * Describes the enum gx.webscrape.resources.ProviderType.
 */
export const ProviderTypeSchema = /*@__PURE__*/
  enumDesc(file_services_webscrape_resources_webscrape, 0);

/**
 * @generated from enum gx.webscrape.resources.ProviderType
 */
export const ProviderType = /*@__PURE__*/
  tsEnum(ProviderTypeSchema);

